<div class="container mt-4" dir="rtl">

  <h3 class="mb-4 fw-bold text-primary"> 🍳 آشپزی</h3>
  <!-- دکمه افزودن دستور پخت جدید -->
  <div class="d-flex justify-content-end mb-4">
    <button class="btn btn-lg btn-primary shadow-sm" (click)="openModal()">
      <i class="fas fa-plus-circle me-2"></i> دستور پخت جدید
    </button>
  </div>

     <!-- 🔍 نوار جستجو -->
  <div class="mb-3">
    <input
      type="text"
      class="form-control shadow-sm"
       placeholder="جستجوی نام غذا، دستور پخت یا مواد مورد نیاز..."
      [(ngModel)]="searchText"
      (input)="onSearch()"
    />
  </div>

   <!-- 🟪 نسخه موبایل: نمایش کارتی -->
  <div class="d-block d-md-none">
    <div *ngFor="let item of anyList" class="card mb-3 shadow-sm">
      <div class="card-body">
        <h5 class="card-title fw-bold">{{ item.food_Name }}</h5>
        <h5 class="card-title fw-bold">{{ item.cook_Order }}</h5>
        <h5 class="card-title fw-bold">{{ item.description }}</h5>
        <h5 class="card-title fw-bold">{{ item.food_Type }}</h5>

        <div class="mt-2 text-end">
          <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(item)">ویرایش</button>
          <button class="btn btn-danger btn-sm" (click)="delete(item.id)">حذف</button>
        </div>
      </div>
    </div>
  </div>

  <!-- نسخه دسکتاپ: نمایش جدولی -->
  <div class="d-none d-md-block table-responsive shadow-lg rounded">
    <table class="table table-hover align-middle mb-0 custom-table text-end">
      <thead class="custom-thead table-primary">
        <tr>
          <th style="width: 13%;">نام غذا</th>
          <th style="width: 35%;">دستور پخت</th>
          <th style="width: 22%;">مواد مورد نیاز</th>
          <th style="width: 12%;">نوع غذا</th>
          <th style="width: 18%;">عملیات</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredList">
          <!-- نام غذا -->
          <td class="text-truncate" style="max-width: 100px;">{{ item.food_Name }}</td>

          <!-- دستور پخت - با قابلیت کلیک برای نمایش کامل -->
          <td
            class="text-truncate"
            style="max-width: 250px; cursor: pointer; color: #007bff;"
            (click)="openDetailModal(item)"
            data-bs-toggle="modal"
            data-bs-target="#cookingDetailModal"
          >
            {{ item.cook_Order }}
            <!-- در اینجا کل متن را نمایش می‌دهیم تا در Modal جزئیات، متن کامل قابل خواندن باشد.
                 اگر می‌خواهید در جدول هم خلاصه باشد، می‌توانید از slice استفاده کنید:
                 {{ item.cook_Order.split(' ').slice(0, 10).join(' ') }}... -->
          </td>

          <!-- توضیحات -->
          <td class="text-truncate" style="max-width: 150px;">{{ item.description }}</td>

          <!-- نوع غذا -->
          <td>{{ item.food_Type }}</td>

          <!-- عملیات -->
          <td>
            <!-- دکمه ها در یک div قرار گرفتند و راست چین شدند -->
            <div class="d-flex justify-content-end flex-wrap" style="gap: 0.5rem;">
              <button
                class="btn btn-warning btn-sm"
                (click)="openEditModal(item)"
              >
                ✏️ ویرایش
              </button>
              <button
                class="btn btn-danger btn-sm"
                (click)="delete(item.id)"
              >
                🗑 حذف
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="filteredList.length === 0">
          <td colspan="5" class="text-center alert alert-info mt-3">دستور پختی یافت نشد.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- 🟪 نسخه موبایل: نمایش کارتی (اگر نیاز است، اضافه کنید) -->
  <!--
  <div class="d-block d-md-none">
    <div *ngFor="let item of filteredList" class="card mb-3 shadow-sm">
      <div class="card-body">
        <h5 class="card-title fw-bold">{{ item.food_Name }}</h5>
        <p class="card-text text-primary" style="cursor:pointer;" (click)="openDetailModal(item)" data-bs-toggle="modal" data-bs-target="#cookingDetailModal">
          {{ item.cook_Order.split(' ').slice(0, 15).join(' ') }}...
        </p>
        <p class="card-text"><small class="text-muted">نوع: {{ item.food_Type }}</small></p>
        <p class="card-text"><small class="text-muted">توضیحات: {{ item.description }}</small></p>
        <div class="mt-2 text-end">
          <button class="btn btn-warning btn-sm me-1" (click)="openEditModal(item)">✏️ ویرایش</button>
          <button class="btn btn-danger btn-sm" (click)="delete(item.id)">🗑 حذف</button>
        </div>
      </div>
    </div>
  </div>
  -->


  <!-- Modal افزودن/ویرایش -->
  <div class="modal fade" #userModal id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-header bg-primary text-white py-3">
          <h5 class="modal-title fw-bold" id="userModalLabel">
            {{ anyObj.id ? '✏️ ویرایش دستور پخت' : '➕ افزودن دستور پخت جدید' }}
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" (click)="closeModal()" aria-label="بستن"></button>
        </div>
        <div class="modal-body p-4">
          <form id="userForm" class="row g-3 needs-validation" novalidate>
            <div class="col-md-6">
              <label for="food_Name" class="form-label fw-bold">نام غذا</label>
              <input
                type="text"
                [(ngModel)]="anyObj.food_Name"
                name="food_Name"
                id="food_Name"
                class="form-control form-control-lg shadow-sm"
                placeholder="مثال: قورمه سبزی"
                required
                [ngModelOptions]="{standalone: true}"
              />
              <div class="invalid-feedback">لطفاً نام غذا را وارد کنید.</div>
            </div>

            <div class="col-md-12">
              <label for="cook_Order" class="form-label fw-bold">دستور پخت</label>
              <textarea
                [(ngModel)]="anyObj.cook_Order"
                name="cook_Order"
                id="cook_Order"
                class="form-control form-control-lg shadow-sm"
                placeholder="روش پخت غذا   ..."
                rows="4"
                required
                [ngModelOptions]="{standalone: true}"
              ></textarea>
               <div class="invalid-feedback">لطفاً دستور پخت غذا را وارد کنید.</div>
            </div>

            <div class="col-md-12">
              <label for="description" class="form-label fw-bold"> مواد مورد نیاز</label>
              <textarea
                [(ngModel)]="anyObj.description"
                name="description"
                id="description"
                class="form-control form-control-lg shadow-sm"
                placeholder="مواد مورد نیاز     ..."
                rows="4"
                required
                [ngModelOptions]="{standalone: true}"
              ></textarea>
               <div class="invalid-feedback">لطفاً مواد مورد نیازبرای پخت غذا را وارد کنید.</div>
            </div>

            <div class="col-md-6">
              <label for="food_Type" class="form-label fw-bold">نوع غذا</label>
              <input
                type="text"
                [(ngModel)]="anyObj.food_Type"
                name="food_Type"
                id="food_Type"
                class="form-control form-control-lg shadow-sm"
                placeholder="مثال: خورشت، کباب، پیش غذا"
                required
                [ngModelOptions]="{standalone: true}"
              />
               <div class="invalid-feedback">لطفاً نوع غذا را وارد کنید.</div>
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-start py-3 px-4">
          <button type="button" class="btn btn-secondary btn-lg shadow-sm" data-bs-dismiss="modal" (click)="closeModal()">
             <i class="fas fa-times-circle me-1"></i> بستن
          </button>
          <button type="button" (click)="onSave()" class="btn btn-success btn-lg shadow-sm">
            <i class="fas fa-save me-1"></i> {{ anyObj.id ? 'ذخیره تغییرات' : 'افزودن دستور پخت' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal نمایش متن کامل دستور پخت -->
  <div class="modal fade" id="cookingDetailModal" tabindex="-1" aria-labelledby="cookingDetailModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" style="word-wrap: break-word; overflow-wrap: break-word;">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-header bg-primary text-white py-3">
          <h5 class="modal-title fw-bold" id="cookingDetailModalLabel">{{ detailObj?.food_Name }}</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="بستن"></button>
        </div>
        <div class="modal-body" style="white-space: pre-line; text-align: justify; word-break: break-word;">
          <!-- نمایش متن کامل دستور پخت -->
          <p class="fs-5">{{ detailObj?.cook_Order }}</p>
        </div>
        <div class="modal-footer justify-content-start py-3 px-4">
          <button type="button" class="btn btn-secondary btn-lg shadow-sm" data-bs-dismiss="modal">
            <i class="fas fa-times-circle me-1"></i> بستن
          </button>
        </div>
      </div>
    </div>
  </div>

</div>


<!-- برای استفاده از آیکون‌های Font Awesome، این لینک را در <head> فایل index.html خود اضافه کنید -->
<!-- <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"> -->
